import React, { useState } from 'react';
import PersonInputModal from './PersonInputModal';

const AddOther = ({ onSubmit, onClose }) => {
  const [formData, setFormData] = useState({
    woodType: '',
    item: '',
    limit: '',
    info: '',
    amount: '',
    isHandRail: false,
    isOther: true
  });
  const [showPersonModal, setShowPersonModal] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowPersonModal(true); // Show the person input modal
  };

  const handlePersonConfirm = (name) => {
    onSubmit(formData, name); // Pass the person's name to onSubmit
    setShowPersonModal(false);
    onClose(); // Close the AddOther window after submission
  };

  const handlePersonCancel = () => {
    setShowPersonModal(false);
  };

  const handleCancel = () => {
    onClose(); // Close the AddOther window on cancel
  };

  return (
    <div className="modal-backdrop">
      <div className="modal-window modal-window--narrow">
        <h2 className="modal-title">Lisää muu tuote</h2>
        <form onSubmit={handleSubmit} className="modal-form">
          <div className="modal-form__column">
          <label htmlFor="woodtype-input">Tuoteryhmä:</label>
          <input
            type="text"
            name="woodType"
            value={formData.woodType}
            onChange={handleChange}
            required
            placeholder="Esim. 'Q-Railing' tai 'Muut'"
            className="modal-input"
          />
            <label htmlFor="item-input">Tuote:</label>
            <input
              type="text"
              name="item"
              value={formData.item}
              onChange={handleChange}
              required
              className="modal-input"
            />
            <label htmlFor="info-input">Tiedot:</label>
            <input
              type="text"
              name="info"
              value={formData.info}
              onChange={handleChange}
              required
              className="modal-input"
            />
          </div>
          <div className="modal-form__column">
            <label htmlFor="limit-input">Varmuusraja:</label>
            <input
              type="text"
              name="limit"
              value={formData.limit}
              onChange={handleChange}
              required
              className="modal-input"
            />
            <label htmlFor="amount-input">Määrä:</label>
            <input
              type="number"
              name="amount"
              value={formData.amount}
              onChange={handleChange}
              required
              className="modal-input"
            />
          </div>
          <div className="modal-form__actions modal-actions--center">
            <button type="button" onClick={handleCancel} className="btn btn-ghost">Peru</button>
            <button type="submit" className="btn btn-primary">Lisää tuote</button>
          </div>
        </form>
      </div>
      {showPersonModal && <PersonInputModal item={"Lisää muu tuote"} onConfirm={handlePersonConfirm} onCancel={handlePersonCancel} />}
    </div>
  );
};

export default AddOther;
